import { Check, ShieldCheck } from "lucide-react";
import { useT } from "@/lib/i18n";

export const DOCS = ["pan", "pcc", "gst", "business_reg"];

export const VerifyList = ({ b, testid = "verify-list", dark }) => {
  const { t } = useT();
  const items = [...(b.visited ? ["visited"] : []), ...DOCS.filter((k) => b.verified_docs?.includes(k))];
  if (!items.length) return null;
  return (
    <ul className="grid gap-2 sm:grid-cols-2" data-testid={testid}>
      {items.map((k) => (
        <li key={k} className={`flex items-center gap-2 text-sm font-semibold ${dark ? "text-white" : "text-emerald-900"}`} data-testid={`${testid}-${k}`}>
          <span className="grid h-5 w-5 flex-shrink-0 place-items-center rounded-full bg-emerald-500 text-white"><Check className="h-3.5 w-3.5" strokeWidth={3} /></span>
          {t(`v_${k}`)}{k === "gst" && b.gstin ? <span className="font-mono text-xs font-normal opacity-80"> · GSTIN {b.gstin}</span> : null}
        </li>
      ))}
    </ul>
  );
};

export const ChecksPill = ({ b }) => {
  const { t } = useT();
  const n = (b.visited ? 1 : 0) + (b.verified_docs?.length || 0);
  if (!n) return null;
  return (
    <span className="inline-flex items-center gap-1 rounded-full border border-emerald-200 bg-emerald-50 px-2 py-0.5 text-[11px] font-bold text-emerald-800" data-testid="business-card-checks">
      <ShieldCheck className="h-3.5 w-3.5" />{t("n_checks", { n })}
    </span>
  );
};
